import { apiSlice } from "../../app/apiSlice"

export const termsAndConditionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getTermsAndConditions: build.query<any, void>({
      query: () => ({
        url: "/terms-and-conditions/public/gift_cards",
        method: "GET",
      }),
    }),
  }),
})

export const {
  useGetTermsAndConditionsQuery,
} = termsAndConditionsApiSlice
